import { SYSAction } from "../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import {
  FormIsValid,
  FormReset,
  SYSFormState,
} from "../../../../../../../_ovlclient/src/library/forms/formapi"
import {
  ProcessStart,
  ProcessEnd,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import {
  ScreenCurrent,
  ScreenNavigateBack,
} from "../../../../../../../_ovlclient/src/library/screenapi"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"

const SaveFeedback: SYSAction<SYSFormState> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  if (FormIsValid(value)) {
    ProcessStart("GENSaveFeedback", { lock: { formState: value } })
    try {
      let res = await Data("data/savefeedback", {
        language: state.ovl.session.Language,
        message: value.fields["msg"].value,
        orderDate: state.app.features.DATFeedback.orderDate,
        orderNum: state.app.features.DATFeedback.orderNum,
        refNum: state.app.features.DATFeedback.refNum,
        assignedTo: state.app.global.DAT.partner.salesContact.id,
        feedbackType: state.app.features.DATFeedback.type,
      })

      if (res.status !== 200) {
        return
      }

      if (ScreenCurrent() === "DATFeedback") {
        await ScreenNavigateBack()
      }
      FormReset(value)
    } finally {
      ProcessEnd("GENSaveFeedback")
    }
  }
}

type OrderFeedbackState = {
  message: string
}
const PreparePositiveFeedback: SYSAction<OrderFeedbackState> = (
  value,
  { global }
) => {
  let state = global.getState()
  // if feedback is left "" empty it shouldn't be displayed
  let key = state.app.screens.DATOrder.orderDetailFormState.selectedOrder
  let order = state.app.screens.DATOrder.orderDetail.orders[key]
  state.app.features.DATFeedback.cardCode = order.cardCode
  state.app.features.DATFeedback.refNum = order.refNum
  state.app.features.DATFeedback.message = value.message
  state.app.features.DATFeedback.title =
    T("DATDocumentDataOrderFeedback") + " " + T("GENPositiveFeedback")
  state.app.features.DATFeedback.orderDate = order.docDate
  state.app.features.DATFeedback.orderDeliveryDate = order.deliveryDate
  state.app.features.DATFeedback.orderNum = key
  state.app.features.DATFeedback.type = "OrderPositive"
}

const PrepareNegativeFeedback: SYSAction<OrderFeedbackState> = (
  value,
  { global }
) => {
  let state = global.getState()
  // if feedback is left "" empty it shouldn't be displayed
  let key = state.app.screens.DATOrder.orderDetailFormState.selectedOrder
  let order = state.app.screens.DATOrder.orderDetail.orders[key]
  state.app.features.DATFeedback.cardCode = order.cardCode
  state.app.features.DATFeedback.refNum = order.refNum
  state.app.features.DATFeedback.message = value.message
  state.app.features.DATFeedback.title =
    T("DATDocumentDataOrderFeedback") + " " + T("GENNegativeFeedback")
  state.app.features.DATFeedback.orderDate = order.docDate
  state.app.features.DATFeedback.orderDeliveryDate = order.deliveryDate
  state.app.features.DATFeedback.orderNum = key
  state.app.features.DATFeedback.type = "OrderNegative"
}

const PrepareDeliveryDateFeedback: SYSAction<OrderFeedbackState> = (
  value,
  { global }
) => {
  let state = global.getState()
  // if feedback is left "" empty it shouldn't be displayed
  let key = state.app.screens.DATOrder.orderDetailFormState.selectedOrder
  let order = state.app.screens.DATOrder.orderDetail.orders[key]
  state.app.features.DATFeedback.cardCode = order.cardCode
  state.app.features.DATFeedback.refNum = order.refNum
  state.app.features.DATFeedback.message = value.message
  state.app.features.DATFeedback.title =
    T("DATDocumentDataOrderFeedback") +
    " " +
    T("DATDocumentDataDeliveryDateFeedback")
  state.app.features.DATFeedback.orderDate = order.docDate
  state.app.features.DATFeedback.orderDeliveryDate = order.deliveryDate
  state.app.features.DATFeedback.orderNum = key
  state.app.features.DATFeedback.type = "DeliveryDate"
}

const SelectOrder: SYSAction<string> = (value, { global }) => {
  let state = global.getState()
  state.app.screens.DATOrder.orderDetailFormState.selectedOrder = value
}

export let actions = {
  SaveFeedback,
  PreparePositiveFeedback,
  PrepareNegativeFeedback,
  PrepareDeliveryDateFeedback,
  SelectOrder,
}
